import { Pipe, PipeTransform } from '@angular/core';

function getParentName(city: any) {
  let parentName;
  if (city.parent && city.parent.length > 0) {
    city.parent.forEach((p) => {
      if (p.type === 'COUNTRY' || p.type === 20) {
        parentName = p.name;
      }
    });
  }
  return parentName;
}
@Pipe({
  name: 'surfShowCountryPipe',
  pure: true,
})
export class SurfShowCountryPipe implements PipeTransform {
  transform(city: any): string {
    return getParentName(city);
  }
}
